console.log("Custom JS loaded");

function initHeroSlider() {
    let slider = document.querySelector(".hero-slider__slides");
    let slides = slider.querySelectorAll(".hero-slide-wrapper");
    let controls = slider.querySelectorAll(".hero-slider__control");
  
    let autoplay = slider.dataset.autoplay == "true" ? true : false;
    let autoplaySpeed = slider.dataset.autoplaySpeed * 1000;
  
    let activeIndex = 0;
  
    slides[0].classList.add("active");
    slides[0].querySelector(".hero-slide").classList.remove("active");
  
    // if autoplay is enabled: autoplay with pause on hover
    if (autoplay) {
        

        setInterval(() => {
            let mobileVideo = slides[activeIndex].querySelector(".mobile-background-video video");
            let desktopVideo = slides[activeIndex].querySelector(".desktop-background-video video");
            let screenWidth = window.innerWidth;

            if (mobileVideo && screenWidth < 768) {
              if(!mobileVideo.paused) {
                return;
              }
            }
            if (desktopVideo && screenWidth >= 768) {
              if(!desktopVideo.paused) {
                return;
              }
            }
            if (autoplay) {
                activeIndex++;
            if (activeIndex >= slides.length) {
                activeIndex = 0;
            }
                changeHeroSlide(activeIndex, slides, controls);
            }
        }, autoplaySpeed);
  
        slider.addEventListener("mouseover", () => {
            autoplay = false;
        });
        slider.addEventListener("mouseout", () => {
            autoplay = true;
        });
    }
  
    // change slide with controls
    controls.forEach((control, index) => {
        control.addEventListener("click", () => {
            activeIndex = index;
            changeHeroSlide(activeIndex, slides, controls);
        });
    });
}
  
function changeHeroSlide(activeIndex, slides, controls) {
    slides.forEach((slide, index) => {
        if (index == activeIndex) {
            slide.classList.add("active");
        } else {
            slide.classList.remove("active");
        }
    });

    controls.forEach((control, index) => {
        if (index == activeIndex) {
            control.classList.add("active");
        } else {
            control.classList.remove("active");
        }
    });

    // if active slide has video, play it
    let activeSlide = slides[activeIndex];
    let mobileVideo = slides[activeIndex].querySelector(".mobile-background-video video");
    let desktopVideo = slides[activeIndex].querySelector(".desktop-background-video video");
    let screenWidth = window.innerWidth;
    if (mobileVideo && screenWidth < 768) {
        mobileVideo.currentTime = 0;
        mobileVideo.play();
    } else if (desktopVideo && screenWidth >= 768) {
        desktopVideo.currentTime = 0;
        desktopVideo.play();
    }
}

/* ANCHOR DYNAMIC CARDS CAROUSEL FUNCTIONS  
1. On page load call initDynamicCardsCarousel(container) with the container of the carousel
2. Add class 'dynamic-carousel-wrapper' to div with carousel scroll 
3. Add data-scrolling="false" to the carousel wrapper
4. Add class 'dynamic-carousel-item' to each card in the carousel
5. Add class 'active' to the first card in the carousel
6. Add class 'dynamic-carousel-control' to each control button in the carousel
7. Add data-direction="next" or "prev" to each control button in the carousel

** DO NOT ADD STYLES TO THE DYNAMIC CAROUSEL CLASSES **

Example: see featured-cards.liquid section
*/
function initDynamicCardsCarousel(container) {
  let carousel = container.querySelector(".dynamic-carousel-wrapper");
  let cards = container.querySelectorAll(".dynamic-carousel-item");
  let carouselNavItems = container.querySelectorAll(".dynamic-carousel-control");
  let activeCard = carousel.querySelector(".dynamic-carousel-item.active");

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  carousel.addEventListener("scroll", () => {
    if (carousel.dataset.scrolling === "false") {
      handleDynamicCardsCarouselScroll(carousel, cards, carouselNavItems);
    }
  });

  carouselNavItems.forEach((navItem) => {
    navItem.addEventListener("click", () => {
      findDynamicCardsCarouselIndex(
        carousel,
        cards,
        navItem.dataset.direction,
        carouselNavItems
      );
    });
  });

  window.addEventListener("resize", () => {
    checkDynamicCarouselWidth(carousel, carouselNavItems);
  });
}

function checkDynamicCarouselWidth(carousel, carouselNavItems) {
  let carouselInner = carousel.querySelector(".dynamic-carousel-inner");
  let totalCarouselWidth = carouselInner.offsetWidth;
  let header = carousel.previousElementSibling;

  if (window.innerWidth >= totalCarouselWidth) {
    carousel.style.alignItems = "center";
    carousel.style.justifyContent = "center";
    carouselNavItems.forEach((navItem) => {
      navItem.style.display = "none";
    });
    if (header) {
      header.style.justifyContent = "center";
      header.style.alignItems = "center";
    }
  } else {
    carousel.style.alignItems = "";
    carousel.style.justifyContent = "";
    carouselNavItems.forEach((navItem) => {
      navItem.style.display = "";
    });
    if (header) {
      header.style.justifyContent = "";
      header.style.alignItems = "";
    }
  }
}

function findDynamicCardsCarouselIndex(carousel, cards, direction, carouselNavItems) {
  let activeCard = carousel.querySelector(".dynamic-carousel-item.active");
  let newIndex = 0;
  let carouselInner = carousel.querySelector(".dynamic-carousel-inner");
  let cardGap = parseInt(window.getComputedStyle(carouselInner).gap);
  let cardsPerView = window.innerWidth / (activeCard.offsetWidth + cardGap);

  // if cardsPerView decimal is greater than 0.9 round up
  if (cardsPerView - Math.floor(cardsPerView) > 0.9) {
    cardsPerView = Math.ceil(cardsPerView);
  } else {
    cardsPerView = Math.floor(cardsPerView);
  }

  let endIndex = cards.length - cardsPerView;

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  cards.forEach((card, index) => {
    if (card == activeCard) {
      card.classList.remove("active");
      if (direction == "next") {
        newIndex = index + 1;
        if (newIndex == cards.length) {
          newIndex = 0;
        }

        if (newIndex > endIndex) {
          newIndex = 0;
        }
      } else {
        newIndex = index - 1;
        if (newIndex < 0) {
          newIndex = cards.length - 1;
        }

        if (newIndex > endIndex) {
          newIndex = endIndex;
        }
      }
    }
  });

  cards[newIndex].classList.add("active");
  carousel.dataset.scrolling = true;
  cards[newIndex].scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
  setTimeout(() => {
    carousel.dataset.scrolling = false;
  }, 1000);
}

function handleDynamicCardsCarouselScroll(carousel, cards, carouselNavItems) {
  let activeCard = carousel.querySelector(".dynamic-carousel-item.active");
  let cardWidth = activeCard.offsetWidth;
  let scrollLeft = carousel.scrollLeft;
  let newIndex = Math.round(scrollLeft / cardWidth);
  let cardsPerView = Math.floor(window.innerWidth / cardWidth);
  let endIndex = cards.length - cardsPerView;

  checkDynamicCarouselWidth(carousel, carouselNavItems);

  if (newIndex > endIndex) {
    newIndex = endIndex;
  } else if (newIndex < 0) {
    newIndex = 0;
  }

  cards.forEach((card, index) => {
    if (index == newIndex) {
      card.classList.add("active");
    } else {
      card.classList.remove("active");
    }
  });
}

/* END DYNAMIC CARDS CAROUSEL FUNCTIONS */

/* ANCHOR UPDATE CART COUNT IN HEADER */

function updateCartCount() {
  let cartCount = document.querySelector(".main-header--cart-count");
  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .then((data) => {
      cartCount.innerText = "(" + data.item_count + ")";
    });
}

/* ANCHOR New Collection Page Functions */
function toggleSortOptions() {
  let sortWrapper = document.querySelector(".sort-wrapper");
  if (sortWrapper.classList.contains("active")) {
    sortWrapper.classList.remove("active");
  } else {
    sortWrapper.classList.add("active");
  }

  document.addEventListener("click", (e) => {
    if (!sortWrapper.contains(e.target)) {
      sortWrapper.classList.remove("active");
    }
  });
}

function toggleFilterOptions(filter) {
  let filterWrapper = document.querySelector('.collection-filter__group--collapsible[data-filter="' + filter + '"]');
  let innerFilter = filterWrapper.querySelector(".filter__group-inner");
  if (filterWrapper.classList.contains("open")) {
    filterWrapper.classList.remove("open");
    innerFilter.setAttribute("aria-expanded", "false");
    filterWrapper.focus();
  } else {
    filterWrapper.classList.add("open");
    innerFilter.setAttribute("aria-expanded", "true");
    //let firstFilter = filterWrapper.querySelector(".filter-option");
    innerFilter.focus();
  }
}

function toggleMobileFilter(toggle) {
  let filter = document.querySelector(".filter-wrapper");
  let pageOverlay = document.querySelector(".FilterPageOverlay");
  let body = document.querySelector("body");
  let filterBtn = document.querySelector(".mobile-filter-open");

  if (toggle === "open") {
    filter.classList.add("active");
    pageOverlay.classList.add("is-visible");
    if (!filter.dataset.previousOverflow) filter.dataset.previousOverflow = body.style.overflow || 'auto';
    body.style.overflow = "hidden";
    filterBtn.setAttribute('aria-expanded', 'true');
    filter.querySelector('.mobile-filter-close')?.focus({ preventScroll: true });
  } else {
    filter.classList.remove("active");
    pageOverlay.classList.remove("is-visible");
    body.style.overflow = filter.dataset.previousOverflow || 'auto';
    delete filter.dataset.previousOverflow;
    filterBtn.setAttribute('aria-expanded', 'false');
    filterBtn.focus({ preventScroll: true });
  }
}

// Resolve current controls on each click; AJAX updates replace the filter form and opener.
document.addEventListener('click', event => {
  const filter = document.querySelector('.filter-wrapper.active');
  const filterBtn = document.querySelector('.mobile-filter-open');
  if (filter && !filter.contains(event.target) && !filterBtn?.contains(event.target)) {
    toggleMobileFilter('close');
  }
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && document.querySelector('.filter-wrapper.active')) toggleMobileFilter('close');
});

/* ANCHOR Countdown Clock */

function initCountdownClock() {
  let countdown = document.getElementById('countdown');
  let daysElement = document.getElementById('days');
  let hoursElement = document.getElementById('hours');
  let minutesElement = document.getElementById('minutes');
  let secondsElement = document.getElementById('seconds');

  if(countdown) {
    let date = countdown.getAttribute('data-date');
    let time = countdown.getAttribute('data-time');
    let countDownDate = new Date(date + 'T' + time + '-07:00').getTime();

    let x = setInterval(function() {
      let now = new Date().getTime();
      let distance = countDownDate - now;

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysElement.innerHTML = days;
      hoursElement.innerHTML = hours;
      minutesElement.innerHTML = minutes;
      secondsElement.innerHTML = seconds;

      if (distance < 0) {
        clearInterval(x);
        daysElement.innerHTML = '00';
        hoursElement.innerHTML = '00';
        minutesElement.innerHTML = '00';
        secondsElement.innerHTML = '00';
      }
    }, 1000);
  }
}

function removeEmbroideryFromCart(embroideryKey, lineItemKey, lineItemQuantity) {
  let updates = {};
  if(!embroideryKey) {
    updates = {
      [lineItemKey]: 0
    }
  } else {
    updates = {
      [embroideryKey]: 0,
      [lineItemKey]: 0
    };
  }

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    cartRefresh();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateEmbroideryInCart(embroideryKey, lineItemKey, action) {
  let input = document.querySelector(`.js-embroidery-line-quantity[data-key="${lineItemKey}"]`);
  let currentQuantity = parseInt(input.value);

  console.log('embroideryKey:', embroideryKey);
  console.log('lineItemKey:', lineItemKey);

  let updates = {};
  if (action === 'decrease') {
    updates = {
      [embroideryKey]: currentQuantity - 1,
      [lineItemKey]: currentQuantity - 1
    };
  } else if (action === 'increase') {
    updates = {
      [embroideryKey]: currentQuantity + 1,
      [lineItemKey]: currentQuantity + 1
    };
  } else {
    updates = {
      [embroideryKey]: currentQuantity,
      [lineItemKey]: currentQuantity
    };
  }

  console.log('Updating cart with:', updates);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    cartRefresh();    
  })
  .catch((error) => {
    console.error('Error:', error);
  });

}

function cartRefresh() {
  const cartDrawer = document.getElementById('sidebar-cart') || document.querySelector('cart-drawer');
  // Try to refresh the cart drawer if possible
  if (cartDrawer) {
      // If your cart drawer has a refreshCart method, call it
      if (typeof cartDrawer.refreshCart === 'function') {
          cartDrawer.refreshCart().then(() => {
              if (typeof cartDrawer.show === 'function') {
                  cartDrawer.show();
              }
          });
      } else {
          // Fallback: dispatch a cart:refresh event, then open the drawer
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof cartDrawer.show === 'function') {
              cartDrawer.show();
          }
      }
  }
}

/* ANCHOR Video Banner Play/Pause Button */
function togglePlayPauseVideo(button) {
  let video = button.closest('.video-banner').querySelector('.video-banner__media');
  if (video.paused) {
    video.play();
    button.dataset.action = "pause";
  } else {
    video.pause();
    button.dataset.action = "play";
  }
}

/* ANCHOR Collection Tab */
function openCollection(collectionId) {
  let tabs = document.querySelectorAll(".js-collection-tab");
  let contents = document.querySelectorAll(".js-collection-tab-content");

  tabs.forEach((tab) => {
    if (tab.dataset.collection == collectionId) {
      tab.classList.add("active");
      
      // Scroll the tab into view within its container
      const container = tab.closest('.collection-tabs');
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const scrollLeft = container.scrollLeft + (tabRect.left - containerRect.left) - (containerRect.width / 2) + (tabRect.width / 2);
        
        container.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    } else {
      tab.classList.remove("active");
    }
  });

  contents.forEach((content) => {
    if (content.dataset.collection == collectionId) {
      content.classList.add("active");
    } else {
      content.classList.remove("active");
    }
  });

}

/* ANCHOR Embroidery Icon Preview */
function getVariantColorPicker() {
  return document.querySelector(".variant-picker__option-values[data-option-name='Color'], .variant-picker__option-values[data-option-name='Sweater Color']");
}

function getSwatchElement(container) {
  const checkedInput = container?.querySelector('input:checked');
  if (!checkedInput) return null;

  const label = container.querySelector(`label[for="${checkedInput.id}"]`);
  if (!label) return null;

  return label.querySelector('.block-swatch__color') || label;
}

function getSwatchBackground(swatchEl) {
  if (!swatchEl) return null;
  return getComputedStyle(swatchEl).getPropertyValue('--swatch-background').trim() || null;
}

const EMBROIDERY_PREVIEW_SWATCH_WIDTH = 800;

function getHighResSwatchImageUrl(url) {
  try {
    const imageUrl = new URL(url, window.location.origin);
    imageUrl.searchParams.set('width', String(EMBROIDERY_PREVIEW_SWATCH_WIDTH));
    return imageUrl.toString();
  } catch {
    if (/[?&]width=\d+/.test(url)) {
      return url.replace(/([?&]width=)\d+/, `$1${EMBROIDERY_PREVIEW_SWATCH_WIDTH}`);
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${EMBROIDERY_PREVIEW_SWATCH_WIDTH}`;
  }
}

function applySwatchBackground(element, container) {
  const swatchBackground = getSwatchBackground(getSwatchElement(container));
  if (!swatchBackground) return;

  const urlMatch = swatchBackground.match(/url\((['"]?)(.*?)\1\)/);
  if (urlMatch) {
    element.style.backgroundColor = '';
    element.style.backgroundImage = `url(${getHighResSwatchImageUrl(urlMatch[2])})`;
    element.style.backgroundSize = 'cover';
    element.style.backgroundPosition = 'center';
    element.style.backgroundRepeat = 'no-repeat';
    return;
  }

  element.style.backgroundImage = '';
  const gradientMatch = swatchBackground.match(/linear-gradient\([^,]+,\s*([^,)]+)/);
  element.style.backgroundColor = gradientMatch ? gradientMatch[1].trim() : swatchBackground;
}

function getColorFromSwatch(container) {
  const swatchBackground = getSwatchBackground(getSwatchElement(container));
  if (!swatchBackground) return null;

  const urlMatch = swatchBackground.match(/url\((['"]?)(.*?)\1\)/);
  if (urlMatch) return null;

  const gradientMatch = swatchBackground.match(/linear-gradient\([^,]+,\s*([^,)]+)/);
  return gradientMatch ? gradientMatch[1].trim() : swatchBackground;
}

function initEmbroideryIconPreview() {
  const variantPicker = document.querySelector('variant-picker');
  const form = variantPicker ? document.forms[variantPicker.getAttribute('form-id')] : null;

  updateEmbroideryIconPreview();

  if (form) {
    form.addEventListener('variant:change', () => {
      updateEmbroideryIconPreview();
    });
  }

  const threadColorPicker = document.querySelector(".line-item-property[data-option-name='Thread Color']");
  threadColorPicker?.addEventListener('change', () => {
    updateEmbroideryIconPreview();
  });
}

function updateEmbroideryIconPreview() {
  const embroideryIconPreview = document.querySelector('.js-embroidery-icon-preview');
  if (!embroideryIconPreview) return;

  applySwatchBackground(embroideryIconPreview, getVariantColorPicker());

  const threadColorPicker = document.querySelector(".line-item-property[data-option-name='Thread Color']");
  const selectedThreadColor = getColorFromSwatch(threadColorPicker);
  if (selectedThreadColor) {
    embroideryIconPreview.querySelectorAll('path').forEach((icon) => {
      icon.style.fill = selectedThreadColor;
    });
  }
}

/* ANCHOR Collection Subcategories */
function scrollCollectionSubcategoryToItem(mainContainer, item, behavior = "smooth") {
  if (!mainContainer || !item) return;

  const targetScrollLeft =
    mainContainer.scrollLeft +
    item.getBoundingClientRect().left -
    mainContainer.getBoundingClientRect().left;

  mainContainer.scrollTo({ left: targetScrollLeft, behavior });
}

function collectionSubcategoriesFitsInView(mainContainer) {
  if (!mainContainer) return true;
  const inner = mainContainer.querySelector(".js-collection-subcategories-container");
  if (!inner) return true;
  return inner.scrollWidth <= mainContainer.clientWidth + 1;
}

function updateCollectionSubcategoriesLayout(mainContainer, container, buttons, scrollPosition) {
  const fitsInView = collectionSubcategoriesFitsInView(mainContainer);
  mainContainer.classList.toggle("is-scrollable", !fitsInView);

  if (fitsInView) {
    buttons.forEach((button) => button.classList.add("hidden"));
    container.dataset.scrollPosition = 0;
    return true;
  }

  updateCollectionSubcategoriesButtons(scrollPosition, getCollectionSubcategoriesMaxScroll(mainContainer, container), buttons);
  return false;
}

function getCollectionSubcategoriesItemWidth(container) {
  const item = container.querySelector(".js-collection-subcategories-item");
  return item ? item.offsetWidth : 136;
}

function getCollectionSubcategoriesMaxScroll(mainContainer, container) {
  const items = container.querySelectorAll(".js-collection-subcategories-item");
  const containerGap = parseInt(window.getComputedStyle(container).gap) || 16;
  const itemWidth = getCollectionSubcategoriesItemWidth(container);
  const itemsPerView = Math.floor(mainContainer.offsetWidth / (itemWidth + containerGap));
  return Math.max(0, items.length - itemsPerView);
}

function updateCollectionSubcategoriesButtons(scrollPosition, maxScrollPosition, buttons) {
  if (scrollPosition <= 0) {
    buttons[0].classList.add("hidden");
  } else {
    buttons[0].classList.remove("hidden");
  }

  if (scrollPosition >= maxScrollPosition) {
    buttons[1].classList.add("hidden");
  } else {
    buttons[1].classList.remove("hidden");
  }
}

function collectionSubcategoriesInit(scope = document, { scrollLeft } = {}) {
  let items = scope.querySelectorAll(".js-collection-subcategories-item");
  let container = scope.querySelector(".js-collection-subcategories-container");
  let mainContainer = scope.querySelector(".js-collection-subcategories-main-container");
  let buttons = scope.querySelectorAll(".js-collection-subcategories-control-btn");

  if (!container || !mainContainer || !buttons.length) return;
  mainContainer.collectionSubcategoriesDestroy?.();
  const events = new AbortController();
  const options = { signal: events.signal };
  let resizeObserver;
  mainContainer.collectionSubcategoriesDestroy = () => {
    events.abort();
    resizeObserver?.disconnect();
  };

  // Default: both arrows stay hidden until overflow is confirmed
  buttons.forEach((button) => button.classList.add("hidden"));

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      collectionSubcategoriesScroll(button.dataset.direction, items, container, buttons);
    }, options);
  });

  mainContainer.addEventListener("scroll", () => {
    handleCollectionSubcategoriesScroll(container, items, buttons);
  }, options);

  const syncLayout = () => {
    const scrollPosition = parseInt(container.dataset.scrollPosition) || 0;
    updateCollectionSubcategoriesLayout(mainContainer, container, buttons, scrollPosition);
  };

  window.addEventListener("resize", syncLayout, options);

  let scrollPosition = 0;
  items.forEach((item, index) => {
    if (item.classList.contains("active")) scrollPosition = index;
  });

  container.dataset.scrollPosition = scrollPosition;

  const applyLayout = () => {
    const fitsInView = updateCollectionSubcategoriesLayout(mainContainer, container, buttons, scrollPosition);

    if (items.length && !fitsInView) {
      if (scrollLeft !== undefined) mainContainer.scrollLeft = scrollLeft;
      else scrollCollectionSubcategoryToItem(mainContainer, items[scrollPosition], "auto");
      handleCollectionSubcategoriesScroll(container, items, buttons);
    }
  };

  applyLayout();

  // Re-check after images load — item width can change once images resolve
  const images = container.querySelectorAll("img");
  let pendingImages = 0;
  images.forEach((img) => {
    if (img.complete) return;
    pendingImages += 1;
    img.addEventListener("load", () => {
      pendingImages -= 1;
      if (pendingImages <= 0) applyLayout();
    }, { once: true, signal: events.signal });
  });

  if (typeof ResizeObserver !== "undefined") {
    resizeObserver = new ResizeObserver(syncLayout);
    resizeObserver.observe(mainContainer);
    resizeObserver.observe(container);
  }
}

document.addEventListener('shopify:section:load', event => {
  if (event.target.querySelector('[data-collection-subcategories]')) collectionSubcategoriesInit(event.target);
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelector('.js-collection-subcategories-main-container')?.collectionSubcategoriesDestroy?.();
});

function collectionSubcategoriesScroll(direction, items, container, buttons) {
  let scrollPosition = parseInt(container.dataset.scrollPosition);
  let mainContainer = container.closest(".js-collection-subcategories-main-container");

  if (collectionSubcategoriesFitsInView(mainContainer)) {
    updateCollectionSubcategoriesLayout(mainContainer, container, buttons, 0);
    return;
  }

  let maxScrollPosition = getCollectionSubcategoriesMaxScroll(mainContainer, container);

  let newScrollPosition = direction === "left" ? scrollPosition - 1 : scrollPosition + 1;
  newScrollPosition = Math.max(0, Math.min(newScrollPosition, maxScrollPosition));

  if (newScrollPosition === scrollPosition) {
    return;
  }

  updateCollectionSubcategoriesButtons(newScrollPosition, maxScrollPosition, buttons);

  container.classList.add("scrolling");
  scrollCollectionSubcategoryToItem(mainContainer, items[newScrollPosition]);
  container.dataset.scrollPosition = newScrollPosition;
  setTimeout(() => {
    container.classList.remove("scrolling");
  }, 1000);
}

function handleCollectionSubcategoriesScroll(container, items, buttons) {
  let mainContainer = container.closest(".js-collection-subcategories-main-container");
  let containerGap = parseInt(window.getComputedStyle(container).gap) || 16;
  let maxScrollPosition = getCollectionSubcategoriesMaxScroll(mainContainer, container);

  if (collectionSubcategoriesFitsInView(mainContainer)) {
    updateCollectionSubcategoriesLayout(mainContainer, container, buttons, 0);
    return;
  }

  if(container.classList.contains("scrolling")) {
    return;
  }

  // Hide left when the first card is in view (at or near the start)
  let firstItem = items[0];
  let firstCardInView = false;
  if (firstItem) {
    let containerRect = mainContainer.getBoundingClientRect();
    let firstRect = firstItem.getBoundingClientRect();
    firstCardInView = firstRect.left >= containerRect.left - 4;
  }

  // Treat reaching the end of the scrollable area as the max position
  let scrolledToEnd = mainContainer.scrollLeft + mainContainer.clientWidth >= mainContainer.scrollWidth - 4;

  let newScrollPosition = Math.floor(mainContainer.scrollLeft / (getCollectionSubcategoriesItemWidth(container) + containerGap));
  if (firstCardInView) {
    newScrollPosition = 0;
  }
  if(newScrollPosition > maxScrollPosition || scrolledToEnd) {
    newScrollPosition = maxScrollPosition;
  }
  if(newScrollPosition < 0) {
    newScrollPosition = 0;
  }

  updateCollectionSubcategoriesButtons(newScrollPosition, maxScrollPosition, buttons);
  container.dataset.scrollPosition = newScrollPosition;
}

/* ANCHOR Required Product Variant Selection */
const manualVariantSelectionStates = new Map();
const manualQuickBuySelectionStates = new Map();
const manualVariantSelectionTransferPrefix = "manual-variant-selection:";
const manualVariantSelectionTransferLifetime = 60000;

function getManualVariantSelectionForm(variantPicker) {
  return document.forms[variantPicker.getAttribute("form-id")];
}

function getManualVariantSelectionGroups(variantPicker) {
  return Array.from(variantPicker.querySelectorAll("[data-manual-selection-required]"));
}

function getManualVariantSelectionTransferKey(url) {
  return `${manualVariantSelectionTransferPrefix}${url.pathname}`;
}

function setManualVariantSelectionTransfer(url, selectedOptions = new Set(), selectedPositions = new Set(), selectedValuesByPosition = new Map(), resolveCombination = false) {
  try {
    window.sessionStorage.setItem(getManualVariantSelectionTransferKey(url), JSON.stringify({
      selectedOptions: Array.from(selectedOptions),
      selectedPositions: Array.from(selectedPositions),
      selectedValuesByPosition: Array.from(selectedValuesByPosition.entries()),
      resolveCombination,
      createdAt: Date.now()
    }));
  } catch (error) {
    // Session storage may be unavailable in privacy-restricted browsers.
  }
}

function getManualVariantSelectionTransfer(url, consume = false) {
  try {
    const key = getManualVariantSelectionTransferKey(url);
    const storedValue = window.sessionStorage.getItem(key);
    if (!storedValue) return null;

    const transfer = JSON.parse(storedValue);
    if (consume) {
      window.sessionStorage.removeItem(key);
    }

    if (!transfer.createdAt || Date.now() - transfer.createdAt > manualVariantSelectionTransferLifetime) {
      window.sessionStorage.removeItem(key);
      return null;
    }

    return transfer;
  } catch (error) {
    return null;
  }
}

function removeLegacyManualVariantSelectionParams() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("manual_selection") && !url.searchParams.has("manual_selected_options")) return;

  url.searchParams.delete("manual_selection");
  url.searchParams.delete("manual_selected_options");
  window.history.replaceState(window.history.state, "", url.toString());
}

function shouldRequireManualVariantSelection(variantPicker, transfer) {
  if (["quick_buy", "featured_product"].includes(variantPicker.getAttribute("context"))) {
    return true;
  }

  if (variantPicker.getAttribute("context") !== "main_product") {
    return false;
  }

  const url = new URL(window.location.href);
  const formId = variantPicker.getAttribute("form-id");
  const requestedVariantId = url.searchParams.get("variant");
  const renderedVariantId = JSON.parse(variantPicker.querySelector("script[data-variant]")?.textContent || "{}").id;
  const hasValidDirectVariant = requestedVariantId && String(renderedVariantId) === requestedVariantId;
  return Boolean(transfer) || manualVariantSelectionStates.has(formId) || !hasValidDirectVariant;
}

function setManualVariantSelectionError(group, showError) {
  const message = group.querySelector(".variant-picker__required-message");
  group.classList.toggle("variant-picker__option--invalid", showError);

  group.querySelectorAll("input[data-option-position]").forEach((input) => {
    input.setAttribute("aria-invalid", showError ? "true" : "false");
  });

  if (message) {
    message.hidden = !showError;
  }
}

function updateManualVariantSelectionLabel(group, text) {
  const optionInfoValue = group.querySelector(".variant-picker__option-info .h-stack > span");
  const dropdownValue = group.querySelector('.select [id$="-selected-value"]');

  if (optionInfoValue) {
    optionInfoValue.textContent = text;
  }

  if (dropdownValue) {
    dropdownValue.textContent = text;
  }
}

function isManualVariantSelectionComplete(variantPicker) {
  return getManualVariantSelectionGroups(variantPicker).every((group) => {
    return group.querySelector("input[data-option-position]:checked");
  });
}

function showIncompleteManualVariantSelectionErrors(variantPicker) {
  let firstIncompleteGroup = null;

  getManualVariantSelectionGroups(variantPicker).forEach((group) => {
    const incomplete = !group.querySelector("input[data-option-position]:checked");
    setManualVariantSelectionError(group, incomplete);

    if (incomplete && !firstIncompleteGroup) {
      firstIncompleteGroup = group;
    }
  });

  firstIncompleteGroup?.scrollIntoView({ behavior: "smooth", block: "center" });
}

function updateManualVariantSelectionFormState(variantPicker, status) {
  const form = getManualVariantSelectionForm(variantPicker);
  if (!form) return;

  form.dataset.manualVariantSelectionState = status;

  if (status !== "resolved") {
    const variantIdInput = form.elements.namedItem("id");
    if (variantIdInput) {
      variantIdInput.value = "";
    }
  }
}

function handleManualVariantSelectionSubmit(event) {
  const form = event.currentTarget;
  const formId = form.getAttribute("id");
  const variantPicker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
  if (!variantPicker || !variantPicker.hasAttribute("data-manual-selection-active")) return;

  const state = manualVariantSelectionStates.get(formId);
  if (state?.status === "resolved" || form.dataset.manualVariantSelectionState === "resolved") return;

  if (!isManualVariantSelectionComplete(variantPicker)) {
    showIncompleteManualVariantSelectionErrors(variantPicker);
  }

  event.preventDefault();
  event.stopImmediatePropagation();
}

function handleManualVariantSelectionChange(event) {
  const input = event.target.closest("input[data-option-position]");
  if (!input) return;

  const variantPicker = event.currentTarget;
  const formId = variantPicker.getAttribute("form-id");
  const group = input.closest("[data-manual-selection-required]");
  const existingState = manualVariantSelectionStates.get(formId);
  const selectedOptions = new Set(existingState?.selectedOptions || []);
  const selectedPositions = new Set(existingState?.selectedPositions || []);
  const selectedValuesByPosition = new Map(existingState?.selectedValuesByPosition || []);

  getManualVariantSelectionGroups(variantPicker).forEach((requiredGroup) => {
    const checkedInput = requiredGroup.querySelector("input[data-option-position]:checked");
    if (checkedInput) {
      selectedOptions.add(requiredGroup.dataset.optionHandle);
      selectedPositions.add(checkedInput.dataset.optionPosition);
      selectedValuesByPosition.set(Number(checkedInput.dataset.optionPosition) - 1, checkedInput.dataset.optionValueName);
    }
  });

  if (group) {
    setManualVariantSelectionError(group, false);
    selectedOptions.add(group.dataset.optionHandle);
    selectedPositions.add(input.dataset.optionPosition);
    selectedValuesByPosition.set(Number(input.dataset.optionPosition) - 1, input.dataset.optionValueName);

    const label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const labelText = label?.querySelector("span")?.textContent?.trim();
    if (labelText) {
      updateManualVariantSelectionLabel(group, labelText);
    }
  }

  const nextState = { status: "resolving", selectedOptions, selectedPositions, selectedValuesByPosition };
  manualVariantSelectionStates.set(formId, nextState);
  updateManualVariantSelectionFormState(variantPicker, "resolving");

  if (variantPicker.getAttribute("context") === "main_product") {
    setManualVariantSelectionTransfer(new URL(window.location.href), selectedOptions, selectedPositions, selectedValuesByPosition);
  }

  const quickBuyModal = variantPicker.closest("quick-buy-modal");
  if (quickBuyModal) {
    manualQuickBuySelectionStates.set(quickBuyModal.id, nextState);
  }
}

async function handleManualCombinedProductSelection(event) {
  const link = event.target.closest("[data-combined-product-option] a[href]");
  if (!link) return;

  const variantPicker = event.currentTarget;
  const formId = variantPicker.getAttribute("form-id");
  const state = manualVariantSelectionStates.get(formId);
  const selectedOptions = new Set(state?.selectedOptions || []);
  const selectedPositions = new Set(state?.selectedPositions || []);
  const selectedValuesByPosition = new Map();

  getManualVariantSelectionGroups(variantPicker).forEach((requiredGroup) => {
    const checkedInput = requiredGroup.querySelector("input[data-option-position]:checked");
    if (checkedInput) {
      selectedOptions.add(requiredGroup.dataset.optionHandle);
      selectedPositions.add(checkedInput.dataset.optionPosition);
      selectedValuesByPosition.set(Number(checkedInput.dataset.optionPosition) - 1, checkedInput.dataset.optionValueName);
    }
  });
  const group = link.closest("[data-combined-product-option]");

  if (group.hasAttribute("data-manual-selection-required")) {
    selectedOptions.add(group.dataset.optionHandle);
  }

  const targetUrl = new URL(link.href, window.location.origin);
  const isModifiedNavigation = event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;

  if (isModifiedNavigation) {
    return;
  }

  setManualVariantSelectionTransfer(targetUrl, selectedOptions, selectedPositions, selectedValuesByPosition, true);

  if (!selectedValuesByPosition.size) {
    return;
  }

  event.preventDefault();

  try {
    const productDataUrl = new URL(`${targetUrl.pathname}.js`, targetUrl.origin);
    const product = await fetch(productDataUrl).then((response) => {
      if (!response.ok) throw new Error(`Unable to load combined product: ${response.status}`);
      return response.json();
    });
    const linkedVariantId = targetUrl.searchParams.get("variant");
    const linkedVariant = product.variants.find((variant) => String(variant.id) === linkedVariantId) || product.variants[0];
    const desiredOptions = [...linkedVariant.options];

    selectedValuesByPosition.forEach((optionValueName, optionIndex) => {
      desiredOptions[optionIndex] = optionValueName;
    });

    const matchingVariant = product.variants.find((variant) => variant.options.length === desiredOptions.length && variant.options.every((optionName, index) => optionName === desiredOptions[index]));
    if (matchingVariant) {
      targetUrl.searchParams.set("variant", matchingVariant.id);
    } else {
      targetUrl.searchParams.delete("variant");
    }
  } catch (error) {
    // Fall back to the variant URL supplied by Shopify when product data cannot be loaded.
  }

  window.location.assign(targetUrl.toString());
}

function initializeManualVariantSelection(variantPicker) {
  if (variantPicker.dataset.manualSelectionInitialized === "true") return;

  const requiredGroups = getManualVariantSelectionGroups(variantPicker);
  const form = getManualVariantSelectionForm(variantPicker);
  if (!requiredGroups.length || !form) {
    variantPicker.removeAttribute("data-manual-selection-unresolved");
    return;
  }

  if (variantPicker.dataset.manualCombinedProductSelectionBound !== "true") {
    variantPicker.addEventListener("click", handleManualCombinedProductSelection);
    variantPicker.dataset.manualCombinedProductSelectionBound = "true";
  }

  const pageUrl = new URL(window.location.href);
  const transfer = variantPicker.getAttribute("context") === "main_product" ?
    getManualVariantSelectionTransfer(pageUrl) : null;
  if (!shouldRequireManualVariantSelection(variantPicker, transfer)) {
    variantPicker.removeAttribute("data-manual-selection-unresolved");
    return;
  }

  if (transfer) {
    getManualVariantSelectionTransfer(pageUrl, true);
  }

  variantPicker.dataset.manualSelectionInitialized = "true";
  variantPicker.setAttribute("data-manual-selection-active", "");

  const quickBuyModal = variantPicker.closest("quick-buy-modal");
  const formId = form.getAttribute("id");
  const existingState = manualVariantSelectionStates.get(formId) ||
    (quickBuyModal ? manualQuickBuySelectionStates.get(quickBuyModal.id) : null);
  const selectedOptions = new Set(existingState?.selectedOptions || transfer?.selectedOptions || []);
  const selectedPositions = new Set(existingState?.selectedPositions || transfer?.selectedPositions || []);
  const selectedValuesByPosition = new Map(existingState?.selectedValuesByPosition || transfer?.selectedValuesByPosition || []);
  const transferredValuesByPosition = transfer?.resolveCombination === true ? new Map(transfer.selectedValuesByPosition || []) : new Map();
  let transferredInput;

  requiredGroups.forEach((group) => {
    const inputs = Array.from(group.querySelectorAll("input[data-option-position]"));
    if (!inputs.length) return;

    const requiredInput = inputs.find((input) => !input.disabled) || inputs[0];
    requiredInput.required = true;
    const optionHandle = group.dataset.optionHandle;
    const optionPosition = requiredInput.dataset.optionPosition;
    const transferredValue = transferredValuesByPosition.get(Number(optionPosition) - 1);
    const matchingTransferredInput = transferredValue ? inputs.find((input) => input.dataset.optionValueName === transferredValue) : null;

    if (matchingTransferredInput) {
      inputs.forEach((input) => input.checked = input === matchingTransferredInput);
      transferredInput = matchingTransferredInput;
    }

    const shouldKeepSelection = selectedOptions.has(optionHandle) || selectedPositions.has(optionPosition);

    if (!shouldKeepSelection) {
      inputs.forEach((input) => {
        input.checked = false;
        input.setAttribute("aria-invalid", "false");
      });
      group.querySelectorAll("a.is-selected").forEach((link) => link.classList.remove("is-selected"));

      updateManualVariantSelectionLabel(group, "Select an option");
    } else if (!inputs.some((input) => input.checked)) {
      selectedOptions.delete(optionHandle);
      selectedPositions.delete(optionPosition);
      updateManualVariantSelectionLabel(group, "Select an option");
    }
  });

  const renderedVariant = JSON.parse(variantPicker.querySelector("script[data-variant]")?.textContent || "{}");
  const selectedOptionNames = Array.from(variantPicker.querySelectorAll("input[data-option-position]:checked"))
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
    .map((input) => input.dataset.optionValueName);
  const shouldResolveTransferredCombination = transfer?.resolveCombination === true && transferredInput && (
    !renderedVariant.id ||
    renderedVariant.options?.length !== selectedOptionNames.length ||
    renderedVariant.options.some((optionName, index) => optionName !== selectedOptionNames[index])
  );
  const status = shouldResolveTransferredCombination ? "resolving" : (isManualVariantSelectionComplete(variantPicker) ? "resolved" : "pending");
  const nextState = { status, selectedOptions, selectedPositions, selectedValuesByPosition };
  manualVariantSelectionStates.set(formId, nextState);

  if (quickBuyModal) {
    if (status === "resolved") {
      manualQuickBuySelectionStates.delete(quickBuyModal.id);
    } else {
      manualQuickBuySelectionStates.set(quickBuyModal.id, nextState);
    }
  }

  updateManualVariantSelectionFormState(variantPicker, status);
  variantPicker.removeAttribute("data-manual-selection-unresolved");

  variantPicker.addEventListener("change", handleManualVariantSelectionChange);

  if (form.dataset.manualVariantSelectionSubmitBound !== "true") {
    form.dataset.manualVariantSelectionSubmitBound = "true";
    form.addEventListener("submit", handleManualVariantSelectionSubmit, true);
  }

  if (shouldResolveTransferredCombination) {
    queueMicrotask(() => transferredInput.dispatchEvent(new Event("change", { bubbles: true })));
  }
}

function cleanUpManualVariantSelectionStates() {
  for (const formId of manualVariantSelectionStates.keys()) {
    const variantPicker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
    const form = document.getElementById(formId);

    if (!variantPicker && !form) {
      manualVariantSelectionStates.delete(formId);
    }
  }

  for (const modalId of manualQuickBuySelectionStates.keys()) {
    if (!document.getElementById(modalId)?.querySelector("variant-picker")) {
      manualQuickBuySelectionStates.delete(modalId);
    }
  }
}

function initializeManualVariantSelections(root = document) {
  if (root.matches?.("variant-picker")) {
    initializeManualVariantSelection(root);
  }

  root.querySelectorAll?.("variant-picker").forEach(initializeManualVariantSelection);
}

document.addEventListener("invalid", (event) => {
  const input = event.target.closest?.("[data-manual-selection-required] input[data-option-position]");
  if (!input) return;

  const group = input.closest("[data-manual-selection-required]");
  setManualVariantSelectionError(group, true);
}, true);

document.addEventListener("variant:change", (event) => {
  const formId = event.target?.getAttribute?.("id") || event.detail?.formId;
  if (!formId) return;

  const variantPicker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
  if (!variantPicker) return;

  variantPicker.removeAttribute("data-manual-selection-unresolved");

  if (!manualVariantSelectionStates.has(formId)) return;

  const existingState = manualVariantSelectionStates.get(formId);
  const status = isManualVariantSelectionComplete(variantPicker) ? "resolved" : "pending";
  manualVariantSelectionStates.set(formId, { ...existingState, status });
  updateManualVariantSelectionFormState(variantPicker, status);

});

document.addEventListener("click", (event) => {
  const link = event.target.closest?.("a[data-manual-selection-entry][href]");
  if (!link || event.target.closest("button")) return;

  setManualVariantSelectionTransfer(new URL(link.href, window.location.origin));
}, true);

document.addEventListener("click", (event) => {
  const embroideryAddToCartButton = event.target.closest?.(".js-embroidery-atc-btn");
  if (!embroideryAddToCartButton) return;

  const form = embroideryAddToCartButton.closest("product-form")?.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const formId = form.getAttribute("id");
  const variantPicker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
  const state = manualVariantSelectionStates.get(formId);
  const status = state?.status || form.dataset.manualVariantSelectionState;
  if (!variantPicker || !variantPicker.hasAttribute("data-manual-selection-active") || status === "resolved") return;

  event.preventDefault();
  event.stopImmediatePropagation();
  showIncompleteManualVariantSelectionErrors(variantPicker);
}, true);

removeLegacyManualVariantSelectionParams();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initializeManualVariantSelections();
    cleanUpManualVariantSelectionStates();
  });
} else {
  initializeManualVariantSelections();
  cleanUpManualVariantSelectionStates();
}

const manualVariantSelectionObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        initializeManualVariantSelections(node);
      }
    });
  });

  cleanUpManualVariantSelectionStates();
});
manualVariantSelectionObserver.observe(document.documentElement, { childList: true, subtree: true });
